import { SequenceInterface, SequencePastDueInterface } from "@swivl-mono/types";

export function ComponentsForSequenceType(props: { sequence: SequenceInterface }) {
  if (props.sequence.type === "PAST_DUE") {
    return <SequencePastDueConditions sequence={props.sequence as SequencePastDueInterface} />;
  }
  return <div>Unknown Sequence Type</div>;
}

export function SequencePastDueConditions(props: { sequence: SequencePastDueInterface }) {
  return (
    <div>
      <div>
        Runs when a customer is {props.sequence.conditions.daysPastDue} {props.sequence.conditions.daysPastDue > 1 ? "days" : "day"} past due.
      </div>
    </div>
  );
}
